// SectionCard.jsx
import React from "react";
import { Box, Container, Flex } from "@chakra-ui/react";
import FadeInSection from "../components/animation/FadeInSection";

const SectionCard = ({ children, flexDirection = "row", delay = 0 }) => (
    <FadeInSection delay={delay}>
        <Box bg="white" p={8} borderRadius="lg" boxShadow="lg" mb={8}>
            <Container maxW="7xl">
                <Flex direction={{ base: "column", md: flexDirection }} align="center" gap={8}>
                    {children}
                </Flex>
            </Container>
        </Box>
    </FadeInSection>
);

export default SectionCard;
